import { render } from "./AddBalanceForm.vue?vue&type=template&id=19970440&ts=true&lang=pug"
import script from "./AddBalanceForm.vue?vue&type=script&lang=ts"
export * from "./AddBalanceForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__